// Frogs (MB.5). PURE (ENG-1). A frog eats a small slime / magma cube and produces
// a froglight whose colour is set by the frog's variant (temperate → ochre, warm →
// pearlescent, cold → verdant). The host runs the eat; this owns the pure mapping.

/** Froglight block by frog variant index (temperate/warm/cold). */
export const FROGLIGHT_BY_VARIANT = ['ochre_froglight', 'pearlescent_froglight', 'verdant_froglight'] as const;

/** The froglight a frog of `variant` produces (wraps to the three variants). */
export function froglightFor(variant: number): string {
  const i = ((Math.floor(variant) % 3) + 3) % 3;
  return FROGLIGHT_BY_VARIANT[i]!;
}

/** How close prey must be for a frog's tongue to catch it. */
export const FROG_EAT_RANGE = 1.6;

/** Mobs a frog eats into a froglight (Java: small magma cubes; small slimes are
 *  eaten too, giving a slimeball — here both yield a froglight for simplicity). */
export function isFrogPrey(type: string): boolean {
  return type === 'slime' || type === 'magma_cube';
}

/** The item that breeds frogs (they then lay a tadpole rather than a baby frog). */
export function frogBreedItem(): string {
  return 'slimeball';
}

/** Ticks a tadpole takes to grow into a frog. */
export const TADPOLE_GROW_TICKS = 6000;
export function tadpoleGrowTicks(): number {
  return TADPOLE_GROW_TICKS;
}

const WARM_BIOMES = ['desert', 'jungle', 'savanna', 'badlands', 'mangrove'];
const COLD_BIOMES = ['snow', 'frozen', 'ice', 'taiga'];

/** The frog variant a tadpole grows into for the biome it matures in — warm →
 *  pearlescent (1), cold → verdant (2), temperate → ochre (0). Feeds `froglightFor`. */
export function frogVariantForBiome(biome: string): number {
  if (WARM_BIOMES.some((w) => biome.includes(w))) return 1;
  if (COLD_BIOMES.some((c) => biome.includes(c))) return 2;
  return 0;
}
